export const API_ROUTES = {
  CLIENT_TENDER_BIDS: "/dronetjek/client/tender/bids/",
  CLIENT_TENDER_BIDS_TASKS: "/dronetjek/client/tender/bids/tasks/",
  CLIENT_CO2_BREAKDOWN: (buildingId, lang) =>
    `/dronetjek/client/co2-breakdown/?building_id=${buildingId}&language=${lang}`,
  CLIENT_TENDER_BIDS_COMPARE: "/dronetjek/client/tender/bids/compare/",
  CLIENT_ONGOING_TASKS: (tenderId) => `/dronetjek/client/ongoing/tasks/?tender_id=${tenderId}`,
  EXPORT_EXCEL_BULK: "/dronetjek/export-excel-bulk/",
  CLIENT_BUILDINGS: "/dronetjek/client/buildings/",
  CONTACT_US: "/dronetjek/contact-us/",
  TENDERS: "/dronetjek/tenders/",
  TENDER_BID: (page, perPage) => `/dronetjek/tender/bid?page=${page}&per_page=${perPage}`,
  CONTRACTOR_COMPLETED_TENDERS: "/dronetjek/contractor/completed/tenders/",
  CONTRACTOR_PENDING_TENDERS: "/dronetjek/contractor/pending/tenders/",
  TENDERS_TASKS: "/dronetjek/tenders/tasks/",
  CONTRACTOR_TENDERS: "/dronetjek/contractor/tenders/",
  DETAILED_LABEL: (imageId, lang) => `/dronetjek/detailed-label/?image_id=${imageId}&lang=${lang}`,
  DETAILED_IMAGE_CALIBRATION: (imageId) => `/dronetjek/v2/detailed-image/${imageId}/calibration/`,
  LOGIN: "/dronetjek/login/",
  FORGET_PASSWORD: "/dronetjek/forget-password/",
  ADMIN_DASHBOARD: "/dronetjek/admin/dashboard/",
  DASHBOARD_PROJECTS: "/dronetjek/dashboard/projects/",
  USER_CONTRACTOR: "/dronetjek/user/contractor/",
  CLIENT_TENDER: "/dronetjek/client/tender/",
  CLIENT_DAMAGES_FILTERED: "/dronetjek/client/damages/filtered/",
  GENERATE_PRESIGNED_URL: "/dronetjek/generate-presigned-url/?file_name=:file_name",
  FEEDBACK: "/dronetjek/feedback/",
  FEEDBACK_BULK: "/dronetjek/feedback/bulk/",
  COMMENTS: "/dronetjek/comments/",
  PROJECT_DETAILS: "/dronetjek/project-details/",
  PROJECT_DETAILS_PDF: "/dronetjek/report_view/project-details/",
  BUILDING: "/dronetjek/building/",
  PROJECT_OVERVIEW: "/dronetjek/report_view/project-overview/",
  PROJECT_BOUNDARY: "/dronetjek/report_view/project-overview/",
  PROJECT_BOUNDARY_FALLBACK: "/report_view/project-overview/",
  PROJECT_DAMAGE_MAP: "/dronetjek/report_view/project-damage-map/",
  PROJECT_TERRAIN: "/dronetjek/report_view/project-terrain/",
  BUILDING_ACCESS: "/dronetjek/project_building_access/",
  BUILDING_PDF: "/dronetjek/report_view/building/",
  CHANGE_STATUS: "/dronetjek/change-status/",
  BUILDING_PARTS: "/dronetjek/building-parts/",
  PARTIAL_IMAGE: "/dronetjek/partial-image/",
  PARTIAL_IMAGES: "/dronetjek/partial-images/",
  BUILDING_DETAILS: (buildingId) => `/dronetjek/building/${buildingId}/`,
  DELETE_BUILDING_PART: (partId) => `/dronetjek/building-parts/${partId}/`,
  FETCH_OVERVIEW_ANNOTATIONS: "/dronetjek/overview-annotation/",
  OVERVIEW_ANALYSIS: "/dronetjek/overview-analysis/",
  DETAILED_IMAGE: "/dronetjek/detailed-image/",
  ANNOTATION_MODELS: "/dronetjek/annotation-models/",
  DETAILED_AI_ANNOTATE: "/dronetjek/detailed-ai-annotate/",
  VIDEO_UPLOAD: "/dronetjek/video-upload/",
  VIDEO_STATUS: "/dronetjek/video-status/",
  VIDEO_FRAME_DOWNLOAD: "/dronetjek/video-frame-download/",
  USER_PROFILE: "/dronetjek/profile/",
  CONTRACTOR_PROFILE: "/dronetjek/profile/contractor",
  TENDER_TASKS: "/dronetjek/client/tender/",
  REPORT_TASKS: "/dronetjek/report/tasks/",
  MARKETPLACE_CLIENT: "/dronetjek/client/tender/",
  PROJECT_ACCESS: "/dronetjek/project-access/",
  MEMBER_ACCESS: "/dronetjek/member-access/",
  SETTINGS: "/dronetjek/settings/",
  CLIENT_TENDER_FEEDBACK: "/dronetjek/client/tender/feedback/",
  CONTRACTOR_TENDERS_MANAGERS: (tenderId) =>
    `/dronetjek/contractor/tenders/managers/?tender_id=${tenderId}`,
  ALL_USERS: "/dronetjek/all-users/",
  DELETE_USER: (userId) => `/dronetjek/all-users/?user_id=${userId}`,
  TENDER_TEAM: (tenderId) => `/dronetjek/tender-team/?tender_id=${tenderId}`,
  SUB_USERS: (user_type) => {
    let url = "/dronetjek/sub-users/?";

    if (user_type) url += `user_type=${user_type}`;

    return url;
  },
  INDEPENDENT_USERS: "/dronetjek/inpependent-users/",
  USERS_PREVIEW: "/dronetjek/users-preview/",
  CLIENT_USERS: "/dronetjek/client-users/",
  CLIENT_USER: (userId) => `/dronetjek/client-users/${userId}/`,
  CLIENT_USER_ME: "/dronetjek/client-users/me/",
  SET_PASSWORD: "/dronetjek/set-password/",
  PDF_DATA: "/dronetjek/pdf-data",
  PROJECT_DATA: "/dronetjek/project-data/",
  PROJECT_DETAILS_REPORT: "/dronetjek/project-details/?report=true",
  PROJECT_REPORTS: "/dronetjek/project-reports/",
  PROJECT_DETAIL: (projectId) => `/dronetjek/project-details/${projectId}/`,
  PROJECT_SUMMARY: "/dronetjek/report_view/project-summary",
  GET_PARTIAL_LIST: "/dronetjek/get-partial-list/",
  MOST_DANGEROUS_BUILDINGS: "/dronetjek/client/dashboard/most-dangerous-buildings/",
  DELIVERED_PROJECTS: "/dronetjek/client/dashboard/delivered-projects/",
  CUSTOMER_REPORT: "/dronetjek/customer-report/",
  CLIENT_DASHBOARD: "/dronetjek/client/dashboard/",
  PROPERTY_DETAILS: "/dronetjek/property-details/",
  PDF_DATA_WITH_PARAMS: (reportID, lang) =>
    `/dronetjek/pdf-data/?overviewImageId=${reportID}&language=${lang}`,
  PDF_DATA_GENERATE: "/dronetjek/pdf-data/generate/",
  BUILDING_FETCH_BFE: "/dronetjek/building/fetch-bfe/",
  BUILDING_FETCH_BY_BFE: "/dronetjek/building/fetch-by-bfe/",
  BUILDING_FETCH_PROPERTY_STRUCTURE: "/dronetjek/building/fetch-property-structure/",
  BUILDING_AUTO_CREATE_FROM_BFE: "/dronetjek/building/auto-create-from-bfe/",
  BUILDING_IDENTIFIERS: "/dronetjek/building/identifiers/",
  BUILDING_MERGE: "/dronetjek/building/merge/",
  BUILDING_MERGE_PREVIEW: "/dronetjek/building/merge-preview/",
  BUILDING_UNMERGE: "/dronetjek/building/unmerge/",
  RESEND_INVITE: "/dronetjek/resend-invite/",
  DEACTIVATE_USER: "/dronetjek/deactivate-user/",
  MAINTENANCE_REPORT: (overviewId, reportType) =>
    `/dronetjek/report/?step=maintanence&tab=maintanence&overviewImageId=${overviewId}&reportType=${reportType}`,
  CLASS_DISTRIBUTION_REPORT: (overviewId) =>
    `/dronetjek/report/?overviewImageId=${overviewId}&step=building&tab=class`,
  USER_INFO_REPORT: (overviewId, reportType) =>
    `/dronetjek/report/?overviewImageId=${overviewId}&step=info&tab=user&reportType=${reportType}`,
  PROJECT_INFO_REPORT: (overviewId, reportType) =>
    `/dronetjek/report/?overviewImageId=${overviewId}&step=info&tab=project&reportType=${reportType}`,
  BUILDING_OVERVIEW_REPORT: (overviewId) =>
    `/dronetjek/report/?overviewImageId=${overviewId}&step=building&tab=overview`,
  BUILDING_CONDITION_REPORT: (overviewId, partialImageIds) =>
    `/dronetjek/report/?overviewImageId=${overviewId}&step=building&tab=condition&${partialImageIds
      .map((id) => `partial_image_ids=${id}`)
      .join("&")}`,
  FINANCIAL_REPORT: (overviewId, reportType, lang) =>
    `/dronetjek/report/?overviewImageId=${overviewId}&step=financial&tab=financial&reportType=${reportType}&language=${lang}`,
  REPORT_DESCRIPTION: (partialImageId, buildingPartId, language) => {
    let url = `/dronetjek/report-description/?partialImageId=${partialImageId}`;
    if (buildingPartId !== undefined && buildingPartId !== null && buildingPartId !== "") {
      url += `&buildingPartId=${buildingPartId}`;
    }
    url += `&language=${language}`;
    return url;
  },
  REPORT_DESCRIPTION2: (partialImageId, buildingPartId, language) => {
    let url = `/dronetjek/report-description/?overviewImageId=${partialImageId}`;
    if (buildingPartId !== undefined && buildingPartId !== null && buildingPartId !== "") {
      url += `&buildingPartId=${buildingPartId}`;
    }
    url += `&language=${language}`;
    return url;
  },
  CONTRACTOR_DASHBOARD: "/dronetjek/contractor/dashboard/",
  CONTRACTOR_TENDERS_WORKERS: "/dronetjek/contractor/tenders/workers/",
  EXPORT_EXCEL: "dronetjek/export/excel",
  BUILDING_MATERIALS: (lang) => `/dronetjek/building-materials/?lang=${lang}`,
  EXPORT_EXCEL_POST: (lang) => `/dronetjek/export-excel/?language=${lang}`,
  EXPORT_PROJECT_ZIP_STATUS: (exportId, lang) =>
    `/dronetjek/export-project-zip/status/?export_id=${exportId}&language=${lang}`,
  EXPORT_PROJECT_ZIP_POST: (lang) => `/dronetjek/export-project-zip/?language=${lang}`,
  CONTRACTOR_ONGOING_TASKS: "/dronetjek/contractor/ongoing/tasks/",
  CONTRACTOR_ONGOING_TENDERS: "/dronetjek/contractor/ongoing/tenders/",
  CONTRACTOR_UPLOAD_IMAGE: "/dronetjek/contractor/upload-image",
  BUILDING_PART: "/dronetjek/building-part/",
  TRIGGER_PROJECT_COPY: "/dronetjek/trigger-project-copy/",
  PROJECT_COPY_JOB: (jobId) => `/dronetjek/copy-project-jobs/${jobId}/`,
  PROJECT_COPY_JOBS: "/dronetjek/copy-project-jobs/",
  PARTIAL_ANNOTATION: "/dronetjek/partial-annotation/",
  DRONE_OPERATOR: "/dronetjek/drone-operator/",
  PARTIAL_LABEL: "/dronetjek/partial-label/",
  ANNOTATE_IMAGE: "/dronetjek/annotate-image/",
  OVERVIEW_IMAGES: "/dronetjek/overview-images/",
  REPORT_ELEMENT: (overviewId, buildingPartId, PartialId, reportType) =>
    `/dronetjek/report/?overviewImageId=${overviewId}&step=building&tab=element&buildingPartId=${buildingPartId}&partialImageId=${PartialId}&reportType=${reportType}`,
  HIGHLIGHTED_LABEL: "/dronetjek/highlighted-label/",
  RESET_ANNOTATIONS: (imageId) => `/dronetjek/reset-annotations/${imageId}/`,
  DETAILED_LABEL_DELETE: "/dronetjek/detailed-label/",
  TENDER_BID_POST: "/dronetjek/tender/bid/",
  CONTRACTOR_ONGOING_TASKS_GET: (tenderId) =>
    `/dronetjek/contractor/ongoing/tasks/?tender_id=${tenderId}`,
  ACCESS_MANAGER: (overviewImageId, reportType, language) => {
    let url = `/dronetjek/access-manager/?overviewImageId=${overviewImageId}`;
    if (reportType) url += `&reportType=${reportType}`;
    if (language) url += `&language=${language}`;
    return url;
  },
  DETAILED_LABEL_PUT: "/dronetjek/detailed-label/",
  REPORT_STEPPER: (overviewId, reportType) => {
    let url = `/dronetjek/report-stepper/?overviewImageId=${overviewId}`;
    if (reportType) url += `&reportType=${reportType}`;
    return url;
  },
  DETAILED_LABEL_ONLY: "/dronetjek/detailed-label/",
  LOOKUPS: "/dronetjek/lookups/",
  MOLIO_PRECHECK: "/dronetjek/molio/precheck/",
  ROLES: "/dronetjek/roles/",
  ROLES_PAGINATION: (page, perPage, searchQuery, sortBy, sortDesc, language) => {
    let url = `/dronetjek/roles/?page=${page}&per_page=${perPage}`;
    if (searchQuery) url += `&search_query=${searchQuery}`;
    if (sortBy) url += `&sort_by=${sortBy}`;
    if (sortDesc) url += `&sort_desc=${sortDesc}`;
    if (language) url += `&language=${language}`;

    return url;
  },
  USER_ROLE: "/dronetjek/roles/user/",
  ROLES_PREVIEW: "/dronetjek/roles/preview/",
  ROLE_ASSIGN: "/dronetjek/roles/assign/",
  ROLES_ONBOARDING: "/dronetjek/roles/onboarding/",
  ROLE_DELETE: (id) => `/dronetjek/roles/?id=${id}`,
  PERMISSIONS: "/dronetjek/permissions/",
  ROLE_PERMISSIONS: (id) => `/dronetjek/roles/${id}/permissions/`,
  USER_PERMISSIONS: "/dronetjek/permissions/user/",
  DAMAGED_PARTS: "/dronetjek/damaged-parts/",
  DAMAGED_PART_DETAIL: (id) => `/dronetjek/damaged-parts/${id}/`,
  RESEED_BUILDING_PARTS: "/dronetjek/report/reseed-building-parts/",
  PUBLIC_DAMAGE_SEQUENCE: (token) => `/dronetjek/public/damage/${token}/sequence/`,
};
